import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static classes = ["enabledButton", "enabledHandle", "disabledButton", "disabledHandle"];
  static targets = ["button", "handle", "checkbox"];

  connect() {
    this.update();
  }

  update() {
    const isChecked = this.checkboxTarget.checked;
    this.buttonTarget.classList.toggle(this.enabledButtonClass, isChecked);
    this.buttonTarget.classList.toggle(this.disabledButtonClass, !isChecked);
    this.handleTarget.classList.toggle(this.enabledHandleClass, isChecked);
    this.handleTarget.classList.toggle(this.disabledHandleClass, !isChecked);
  }

  toggle() {
    this.checkboxTarget.checked = !this.checkboxTarget.checked;
    this.checkboxTarget.dispatchEvent(new Event("change"));
    this.update();
  }
}
